import at from '../actionTypes'
import createReducer from './utilities/createReducer'

export default createReducer({}, {
	[at.BRAND_FETCH_BEGIN]: (state) => {
		const newState = { ...state }
		delete newState.brand
		return newState
	},
	[at.BRAND_FETCH_SUCCESS]: (state, action) => ({
		...state,
		brand: action.payload.brand
	})
})



// WEBPACK FOOTER //
// ./src/redux/reducers/brandReducer.js